import { useContext } from 'react';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, Typography, List, ListItem } from '@mui/material';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';
import Moment from 'react-moment';
import { customerTicketDetailsContext } from '../../CustomerTicketDetailsContext';
import { appUserContext } from 'helpers/services';


let Orders = () => {
    let { formatMessage } = useIntl();

    let { isMobile } = useContext(appUserContext);
    let { ticket } = useContext(customerTicketDetailsContext);

    return (
        <>
            {isMobile === false &&
                <Grid>
                    <Grid item xs>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{formatMessage({ id: LocalizationIds.WorkOrder })}</TableCell>
                                    <TableCell>{formatMessage({ id: LocalizationIds.Order })}</TableCell>
                                    <TableCell>{formatMessage({ id: LocalizationIds.Description })}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {ticket.workOrders.map((workOrder, index) =>
                                    <TableRow hover key={index}>
                                        <TableCell>{workOrder.workOrderNumber}</TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                {workOrder.orderType}{workOrder.orderNumber}
                                            </Typography>
                                            {workOrder.orderDate &&
                                                <Typography variant="caption">
                                                    <Moment date={workOrder.orderDate} format="LL" />
                                                </Typography>
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {workOrder.articleId}&nbsp;{workOrder.articleModel}&nbsp;{workOrder.articleVersion}&nbsp;{workOrder.articleDescription}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
            }
            {isMobile === true &&
                <List>
                    {ticket.workOrders.map((workOrder, index) =>
                        <ListItem disableGutters divider key={index}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        <b>{formatMessage({ id: LocalizationIds.WorkOrder })}:</b>&nbsp;
                                    </Typography>
                                    {workOrder.workOrderNumber}
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        <b>{formatMessage({ id: LocalizationIds.Order })}:</b>&nbsp;
                                    </Typography>
                                    {workOrder.orderDate &&
                                        <Typography variant="caption">
                                            <Moment date={workOrder.orderDate} format="LL" />
                                        </Typography>
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        <b>{formatMessage({ id: LocalizationIds.Description })}:</b>&nbsp;
                                    </Typography>
                                    {workOrder.articleId}&nbsp;{workOrder.articleModel}&nbsp;{workOrder.articleVersion}&nbsp;{workOrder.articleDescription}
                                </Grid>
                            </Grid>
                        </ListItem>
                    )}
                </List>
            }
        </>
    )
}

export default Orders;